import { useTranslation } from "react-i18next";
import ContainerLayout from "../../../components/container-layout/ContainerLayout";
import StateComponents from "../../../components/state-component/StateComponents";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useEffect, useState } from "react";
import { Box, Checkbox, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import { ButtonContained } from "../../../components/button/ButtonCustoms";
import ContainerButton from "../../../components/button/ContainerButton";
import { EvidencePayment, FileApplicant, FormApplicant } from "../list-applicants/applicent-detail";
import InputTextField from "../../../components/input/inputTextField";
import { useDispatch } from "react-redux";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { EXAMS, exams_enum } from "../manage-exams/manage-exams-detail";
import { PeriodExaminationApi } from "../../../api/period_examination/period_examination.api";
import { handleTypingNumber } from "../../../utils/app.utils";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { AdmissionFrontApi } from "../../../api/admission-front/admission-front.api";

export default function StudentDetail(props: any) {
  const { view } = props
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();

  const { id, id_admission_student } = useParams()
  const dispatch = useDispatch();
  const [tabStep, setTebStep] = useState(0);
  const [form, setForm] = useState<any>();

  const allStep = [
    {
      name: t("PERIOD_EXAMINATION_PERSONAL_INFO"),
      isAccept: false,
      icon: null
    },
    {
      name: t("PERIOD_EXAMINATION_EXAM_INFO"),
      isAccept: false,
      icon: null
    },

  ];
  const getDetail = async () => {
    dispatch(setLoading());

    await AdmissionFrontApi.findOne(id_admission_student).then((res) => {
      if (res.status < 300) {
        setForm(res.data.data)
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }

  useEffect(() => {
    getDetail()
  }, [])

  return (
    <div className='w-full'>
      <ContainerLayout
        title={t("STUDENT_REGISTRATION_APPLICANT_PERSONAL_INFO")}
        // hidden_sub_title
        navigateContent={
          <NavigateListCustom
            navigateData={[
              {
                key: "complaintSubmit",
                name: t("PERIOD_EXAMINATION"),
                disabled_match: true,
                pathName: routeName.admission.period_examination
              },

              {
                key: "complaintSubmit",
                name: t("STUDENT_REGISTRATION_APPLICANT_PERSONAL_INFO"),
                pathName: routeName.admission.period_examination
              },
            ]}
          />
        }

        content={
          <div className='w-full'>
            <section
              style={{
                display: "flex",
                justifyContent: "start",
                marginTop: "24px",
              }}
            >
              <StepperCustom
                step={tabStep}
                setStep={setTebStep}
                stepLabel={allStep}
                view={true}
              />
            </section>
            {tabStep === 0 &&
              <div style={{ display: 'flex', flexDirection: 'column', gap: "20px" }}>
                <FormApplicant form={form} />
                <FileApplicant form={form} />

              </div>
            }
            {tabStep === 1 &&
              <>
                <ExaminationStudent formStudent={form} view={view} />
              </>
            }
            <ContainerButton
              sxContainer={{ my: 3 }}
              buttonData={[
                {
                  seq: 1,
                  buttonProps: {
                    onClick: () => {
                      navigate('/period-examination/' + id)
                    },
                  },
                  hidden: tabStep !== 0,
                  key: "CANCEL",
                  label: t("PERIOD_EXAMINATION_BACK"),
                  type: "CANCEL"
                },

              ]}
            />
          </div>
        }
      />

    </div>
  )
}


const ExaminationStudent = (props: any) => {
  const { formStudent, view } = props
  const { id, id_period_examination_student } = useParams()
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();

  const dispatch = useDispatch();
  const [form, setForm] = useState<any>();
  // const [periodExaminationDetail, setPeriodExaminationDetail] = useState<any>();
  const [answer, setAnswer] = useState<any[]>([])

  const getDetail = async () => {
    // dispatch(setLoading());

    await PeriodExaminationApi.getPeriodExaminationStudent(id, id_period_examination_student).then((res) => {
      if (res.status < 300) {
        setForm(res.data.data)
        setAnswer(res.data.data?.examination_details?.map((item: any) => {
          return {
            ...item,
            examination_answers: item?.examination_answers?.map((x: any) => {
              return {
                ...x,
                examination_answer_true: x?.student_result?.examination_student_answer === '1',
                examination_answer_true_ex: x?.examination_answer_true,
                examination_answer: x?.student_result?.examination_answer,
                examination_title: x?.examination_answer,

              }
            })
          }
        }))
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      // dispatch(unsetLoading());
    })
  }

  // const getPeriodExaminationDetail = async () => {
  //   dispatch(setLoading());

  //   await PeriodExaminationApi.getPeriodExaminationById(id).then((res) => {
  //     if (res.status < 300) {
  //       setPeriodExaminationDetail(res.data.data)
  //     }
  //   }).catch((err) => {
  //     console.log(err)
  //   }).finally(() => {
  //     dispatch(unsetLoading());
  //   })
  // }
  useEffect(() => {
    // if (id) {
    //   getPeriodExaminationDetail()

    // }
    getDetail()
  }, [])


  const handleSubmit = async () => {
    const body = {
      examination_details: answer?.filter((item: any) => item?.examination_type === EXAMS.ANSWER)?.map((item: any) => {
        return {
          id_examination_detail: item?.id_examination_detail,
          examination_type: item?.examination_type,
          student_point: {
            id_period_examination_student_result: item?.student_point?.id_period_examination_student_result,
            examination_student_point: item?.student_point?.examination_student_point,
          }
        }
      })
    }
    dispatch(setLoading());
    await PeriodExaminationApi.updateStudentScore(id, id_period_examination_student, body)
      .then((res) => {
        if (res.status < 300) {
          alertSuccess(t("PERIOD_EXAMINATION_EXAM_INFO"), t("PERIOD_EXAMINATION_SAVE_SUCCESS"));
          navigate(routeName.admission.period_examination_detail?.replace(':id', `${id}`))
        }
      })
      .catch((err) => {
        console.log(err);
        alertError(t("PERIOD_EXAMINATION_EXAM_INFO"), t("PERIOD_EXAMINATION_SAVE_FAILED"));
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Grid spacing={2} container>
        <Grid item xs={12} md={2}>
          <Box sx={{ background: '#5FB95D', padding: "10px", borderRadius: '8px' }}>
            <Typography sx={{ color: '#fff', fontWeight: '600', fontSize: '18px' }}>{t('PERIOD_EXAMINATION_TOTAL_QUESTIONS')}</Typography>
            <Typography sx={{ color: '#fff', fontWeight: '600', fontSize: '14px', marginTop: "15px" }}>{answer?.length}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={2}>
          <Box sx={{ background: '#F79009', padding: "10px", borderRadius: '8px' }}>
            <Typography sx={{ color: '#fff', fontWeight: '600', fontSize: '18px' }}>{t('PERIOD_EXAMINATION_PASS_SCORE')}</Typography>
            <Typography sx={{ color: '#fff', fontWeight: '600', fontSize: '14px', marginTop: "15px" }}>{formStudent?.examination?.period_examination_pass}</Typography>

          </Box>
        </Grid>
        <Grid item xs={12} md={2}>
          <Box sx={{ border: '1px solid #5FB95D', padding: "10px", borderRadius: '8px' }}>
            <Typography sx={{ color: '#5FB95D', fontWeight: '600', fontSize: '18px' }}>{t('PERIOD_EXAMINATION_SCORE_OBTAINED')}</Typography>
            <Typography sx={{ color: '#5FB95D', fontWeight: '600', fontSize: '14px', marginTop: "15px" }}>{formStudent?.examination?.student_result_score}</Typography>

          </Box>
        </Grid>
        <Grid item xs={12} md={2}>
          <Box sx={{ border: '1px solid #5FB95D', padding: "10px", borderRadius: '8px' }}>
            <Typography sx={{ color: '#5FB95D', fontWeight: '600', fontSize: '18px' }}>{t('PERIOD_EXAMINATION_EXAM_RESULT')}</Typography>
            <Typography sx={{ color: '#5FB95D', fontWeight: '600', fontSize: '14px', marginTop: "15px" }}>{formStudent?.examination?.student_result_score >= formStudent?.examination?.period_examination_pass ? t('ผ่าน') : t('ไม่ผ่าน')}</Typography>

          </Box>
        </Grid>
      </Grid>
      <InputTextField heading={t('PERIOD_EXAMINATION_EXAM_NAME')} value={form?.examination_name} disabled />
      <InputTextField heading={t('PERIOD_EXAMINATION_DESCRIPTION')} value={form?.examination_desc} multiline inputHeight={"auto"} minRow={6} disabled />
      {
        answer.map((item: any, index: number) => {
          return (
            <article key={index + 1} className='col-span-12 mt-6'>
              <Box
                sx={{
                  boxShadow: '0px 0px 2px 2px rgba(0, 0, 0, 0.12)',
                  borderRadius: '10px',
                  borderBottom: '8px solid #0075CB'
                }}
              >
                <Box sx={{ padding: "20px" }}>
                  <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={
                      [
                        {
                          seq: 1,
                          type: "SELECT",
                          gridProps: {
                            xs: 12,
                            md: 4
                          },
                          fieldProps: {
                            disabled: true,
                            labelId: "select_detail_type_" + index,
                            placeholder: t("PERIOD_EXAMINATION_EXAM_TYPE"),
                            heading: t("PERIOD_EXAMINATION_EXAM_TYPE"),
                            options: exams_enum.map((x) => {
                              return {
                                ...x,
                                label: t(x.label)
                              }
                            }),
                            selectId: "select_detail_type_" + index,
                            onChange: (e) => {
                              setAnswer((prevData) =>
                                prevData.map((p: any, i: number) =>
                                  index === i ? {
                                    ...p, examination_type: e.target.value,
                                    examination_answers: e.target.value === EXAMS.ANSWER ? [
                                      {
                                        examination_answer: '',
                                        examination_answer_true: true
                                      }
                                    ] : [{
                                      examination_answer: 'ตัวเลือก', // i18n-ignore
                                      examination_answer_true: true
                                    }]
                                  } : p
                                )
                              );
                            },
                            value: item?.examination_type || ''
                          }
                        },
                        {
                          seq: 2,
                          type: "TEXT_FIELD",
                          gridProps: {
                            xs: 12,
                            md: 12
                          },
                          fieldProps: {
                            multiline: true,
                            row: 3,
                            maxRows: 5,
                            inputHeight: "auto",
                            disablePaddingMultiline: true,
                            disabled: true,
                            placeholder: t("PERIOD_EXAMINATION_QUESTION"),
                            heading: t("PERIOD_EXAMINATION_QUESTION"),
                            onChange: (e) => {
                              setAnswer((prevData) =>
                                prevData.map((p: any, i: number) =>
                                  index === i ? { ...p, examination_question: e.target.value } : p
                                )
                              );
                            },
                            value: item?.examination_question || ''
                          }
                        },
                      ]
                    }
                  />
                  {
                    item?.examination_type === EXAMS.SINGLE_CHOICE &&
                    <Box sx={{ marginTop: 2, width: '100%' }}>

                      <FormControl fullWidth>
                        <RadioGroup>
                          {
                            item.examination_answers && item.examination_answers.length > 0 ?
                              <>

                                {item?.examination_answers?.sort((a: any, b: any) => a?.id_examination_answer - b?.id_examination_answer)?.map((choice: any, choiceindex: any) => {
                                  return (
                                    <FormControlLabel
                                      slotProps={{ typography: { "width": "100%" } }}
                                      key={choiceindex + 1}
                                      id={'choice' + choiceindex}
                                      control={<Radio checked={choice?.examination_answer_true_ex || choice?.examination_answer_true} color={choice?.examination_answer_true_ex ? 'success' : choice?.examination_answer_true ? 'error' : 'default'} />}
                                      // disabled

                                      // checked={ || ''}
                                      onChange={(e: any) => {
                                        // const newValue = e.target.checked;
                                        // setAnswer((prevData) =>
                                        //   prevData.map((q, qIndex) =>
                                        //     qIndex === index
                                        //       ? {
                                        //         ...q,
                                        //         examination_answers: q.examination_answers.map(
                                        //           (ans: any, aIndex: number) =>
                                        //             aIndex === choiceindex
                                        //               ? { ...ans, examination_answer_true: newValue, examination_answer: choice?.examination_answer }
                                        //               : { ...ans, examination_answer_true: false }
                                        //         ),
                                        //       }
                                        //       : q
                                        //   )
                                        // );
                                      }}
                                      label={<Typography sx={{ color: choice?.examination_answer_true_ex ? '#0F9F0C' : choice?.examination_answer_true ? 'red' : '#000' }}>{choice?.examination_title}</Typography>}
                                    />
                                  )
                                })}
                              </>
                              :
                              <></>
                          }

                        </RadioGroup>
                      </FormControl>
                      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: 2, }}>
                        <Typography>{t('PERIOD_EXAMINATION_SCORE')}</Typography>
                        <InputTextField style={{ width: '150px' }} onchange={
                          (e) => {
                            setAnswer((prevData) =>
                              prevData.map((p: any, i: number) =>
                                index === i ? { ...p, student_point: { ...p?.student_point, examination_student_point: e.target.value } } : p
                              )
                            );
                          }
                        } value={item?.student_point?.examination_student_point || '0'} onkeypress={handleTypingNumber} disabled />
                        <Typography>/ {item?.examination_detail_point}</Typography>

                      </Box>
                    </Box>
                  }
                  {
                    item?.examination_type === EXAMS.MULTIPLE_CHOICE &&
                    <Box sx={{ marginTop: 2, width: '100%' }}>

                      <FormControl fullWidth>
                        {
                          item?.examination_answers && item?.examination_answers?.length > 0 ?
                            <>

                              {item.examination_answers?.sort((a: any, b: any) => a?.id_examination_answer - b?.id_examination_answer)?.map((choice: any, choiceindex: any) => {
                                return (
                                  <FormControlLabel
                                    slotProps={{ typography: { "width": "100%" } }}
                                    key={choiceindex + 1}
                                    id={'choice' + choiceindex}
                                    // value={choice.examination_answer + '' + choiceindex}
                                    control={<Checkbox color={choice?.examination_answer_true_ex ? 'success' : choice?.examination_answer_true ? 'error' : 'default'} />}
                                    // disabled
                                    checked={choice?.examination_answer_true_ex || choice?.examination_answer_true}
                                    onChange={(e: any) => {
                                      // const newValue = e.target.checked;
                                      // setAnswer((prevData) =>
                                      //   prevData.map((q, qIndex) =>
                                      //     qIndex === index
                                      //       ? {
                                      //         ...q,
                                      //         examination_answers: q.examination_answers.map(
                                      //           (ans: any, aIndex: number) =>
                                      //             aIndex === choiceindex
                                      //               ? { ...ans, examination_answer_true: newValue, examination_answer: choice?.examination_answer }
                                      //               : ans
                                      //         ),
                                      //       }
                                      //       : q
                                      //   )
                                      // );
                                    }}
                                    label={<Typography sx={{ color: choice?.examination_answer_true_ex ? '#0F9F0C' : choice?.examination_answer_true ? 'red' : '#000' }}>{choice?.examination_title}</Typography>}
                                  />
                                )
                              })}
                            </> :
                            <></>

                        }
                      </FormControl>
                      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: 2, }}>
                        <Typography>{t('PERIOD_EXAMINATION_SCORE')}</Typography>
                        <InputTextField style={{ width: '150px' }} onchange={
                          (e) => {
                            setAnswer((prevData) =>
                              prevData.map((p: any, i: number) =>
                                index === i ? { ...p, student_point: { ...p?.student_point, examination_student_point: e.target.value } } : p
                              )
                            );
                          }
                        } value={item?.student_point?.examination_student_point || '0'} onkeypress={handleTypingNumber} disabled />
                        <Typography>/ {item?.examination_detail_point}</Typography>

                      </Box>
                    </Box>}
                  {item?.examination_type === EXAMS.ANSWER &&
                    <Box sx={{ marginTop: 2, width: '100%' }}>
                      {
                        item.examination_answers && item.examination_answers.length > 0 ?
                          <>

                            {item?.examination_answers?.map((choice: any, choiceindex: any) => (
                              <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={
                                  [

                                    {
                                      seq: 1,
                                      type: "TEXT_FIELD",
                                      gridProps: {
                                        xs: 12,
                                        md: 12
                                      },
                                      fieldProps: {
                                        multiline: true,
                                        row: 3,
                                        maxRows: 5,
                                        inputHeight: "auto",
                                        disablePaddingMultiline: true,
                                        placeholder: t("PERIOD_EXAMINATION_ANSWER"),
                                        heading: t("PERIOD_EXAMINATION_ANSWER"),
                                        disabled: true,
                                        onChange: (e) => {
                                          const newValue = e.target.value;
                                          setAnswer((prevData) =>
                                            prevData.map((q, qIndex) =>
                                              qIndex === index
                                                ? {
                                                  ...q,
                                                  examination_answers: q.examination_answers.map(
                                                    (ans: any, aIndex: number) =>
                                                      aIndex === choiceindex
                                                        ? { ...ans, examination_answer: newValue }
                                                        : ans
                                                  ),
                                                }
                                                : q
                                            )
                                          );
                                        },
                                        value: choice?.examination_answer || ''
                                      }
                                    },
                                  ]
                                }
                              />))}</> : <></>}
                      <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: 2, }}>
                        <Typography>{t('PERIOD_EXAMINATION_SCORE')} </Typography>
                        <InputTextField style={{ width: '150px' }} onchange={
                          (e) => {
                            setAnswer((prevData) =>
                              prevData.map((p: any, i: number) =>
                                index === i ? { ...p, student_point: { ...p?.student_point, examination_student_point: e.target.value } } : p
                              )
                            );
                          }
                        } value={item?.student_point?.examination_student_point || ''} onkeypress={handleTypingNumber} disabled={view || formStudent?.examination?.period_examination_status === 'CONFIRM'} />
                        <Typography>/ {item?.examination_detail_point}</Typography>

                      </Box>
                    </Box>
                  }

                </Box>
              </Box>

            </article>
          )

        })}
      < ContainerButton
        sxContainer={{ my: 3 }}
        buttonData={[
          {
            seq: 1,
            buttonProps: {
              onClick: () => {navigate('/period-examination/' + id)},
            },
            key: "CANCEL",
            label: t("PERIOD_EXAMINATION_BACK"),
            type: "CANCEL"
          },

          {
            seq: 2,
            buttonProps: {
              onClick: () => {
                handleSubmit()
              }
            },
            hidden: view || formStudent?.examination?.period_examination_status === 'CONFIRM',
            key: "NONE",
            label: t("PERIOD_EXAMINATION_CONFIRM"),
            type: 'NONE'
          },

        ]}
      /></Box>
  )
}
